<template>
    <section>
   <data-table url="ivr/calls"  model="Calls" has-filters   date-filter="true" :fields="fields" no-modal></data-table> 
</section>
</template>
<script>
    export default {
        data() {
            return {
              fields:[
              { field: 'from', label: 'Nùmero entrante', sort: true, hasFilter: false, filter: '', filterAdd: null  },
              { field: 'to', label: 'Operadora', sort: true, hasFilter: false, filter: '', filterAdd: null  },
              {field:'created_at', label:'Fecha de llamada', sort:true,hasFilter:true,filter:'date',filterAdd:null},
              {field:'name', label:'Atendiò', sort:true,hasFilter:false,filter:'',filterAdd:null},
              {field:'status', label:'status', sort:true,hasFilter:true,filter:'status',filterAdd:null}
              ],
                currentPage: 1,
                perPage: 10,
                total: 0,
                order: 'desc',
                field: 'id',
                loading: false
            }
        },
        created() {
            this.prepareComponent()
        },
        methods: {
            prepareComponent() {
                this.getData()
            },
            sorted(field, order) {
                this.field = field;
                this.order = order;
                this.getData()
            },
            pageChange(page) {
                this.currentPage = page;
                this.getData()
            },
            getData() {
                this.loading = true
                this.$http.get('ivr/calls', {
                    params: {
                        pagesize: this.perPage,
                        page: this.currentPage,
                        field: this.field,
                        sorting: this.order,
                    }
                }).then(response => {
                    this.loading = false;
                    let res = response.data;
                    this.data = res.data;
                    this.total = res.total
                }, error => {
                    this.loading = false;
                    Toast.danger(error.response.data.message)
                })
            }
        }
    }
</script>


